export const configItemsSubscription = [
  { title: 'Лайкайте анкеты без ограничений', iconUrl: '/icons/bottom_bar_button_1.svg' },
  { title: 'Узнайте кто вас лайкает', iconUrl: '/icons/prem-eye.svg' },
  { title: 'В 5 раз больше супер-лайков', iconUrl: '/icons/prem-fire.svg' },
  { title: 'В 5 раз больше возвратов анкет после дизлайка', iconUrl: '/icons/prem-back.svg' },
  // { title: 'В 15 раз больше видео-знакомств', iconUrl: '/icons/prem-play.svg' },
  // { title: 'Больше лайков в видео-знакомствах', iconUrl: '/icons/prem-lip.svg' },
  { title: 'Расширенные фильтры поиска', iconUrl: '/icons/prem-filter.svg' },
  { title: 'Отсутствие рекламы', iconUrl: '/icons/prem-flag.svg' },
  // { title: 'Бонус: 5 подарков бесплатно', iconUrl: '/icons/prem-gift.svg' },
  // { title: 'Монеты MYTA', iconUrl: '/icons/myta-coin.svg' },
];